<template>
  <li
    :class="
      bemBlockMod({
        fixed: isFixed,
        secondary: isSecondaryLevel,
        'with-separator': hasSeparatorBefore,
        'with-separator-after': hasSeparatorAfter,
      })
    "
    :style="cssCustomProps"
  >
    <a
      v-if="shouldNavigate"
      :class="[
        bemElement('link', {
          secondary: isSecondaryLevel,
          'with-separator': hasSeparatorBefore,
          'with-separator-after': hasSeparatorAfter,
        }),
      ]"
      :href="href"
      @click.prevent="handleClick"
    >
      <slot />
    </a>
    <button
      v-else
      :class="[
        bemElement('link', {
          secondary: isSecondaryLevel,
          'with-separator': hasSeparatorBefore,
        }),
        'u-btn-clean',
      ]"
      @click="handleClick"
    >
      <slot />
    </button>
  </li>
</template>
<script>
import { types } from '../store';
import bemClassesMixin from '../mixins/bemClassesMixin';
import windowResizeMixin from '../mixins/windowResizeMixin';
import { isAbsoluteUrl } from '../../common/utils/url';

export default {
  name: 'TheMenuItem',

  mixins: [bemClassesMixin, windowResizeMixin],

  props: {
    hasSeparatorBefore: {
      type: Boolean,
      default: false,
    },
    hasSeparatorAfter: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      required: false,
      default: '',
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
    isSecondaryLevel: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isTouchDevice: false,
    itemPosition: 0,
    listHeight: 0,
  }),

  computed: {
    cssCustomProps() {
      return {
        '--category-bg-color': null,
        '--category-color': null,
        '--category-color-desktop': null,
        '--subcategory-color': null,
        '--subcategory-color-desktop': null,
        '--subcategory-bg-color': null,
        '--subcategory-bg-color-desktop': null,
        '--item-position': '0px',
      };
    },
    shouldNavigate() {
      // should navigate if category has an href
      return this.href.length > 0;
    },
  },

  methods: {
    handleClick() {
      if (this.shouldNavigate) {
        this.$store.dispatch(types.menu.setMenuState, {});
        // Hack for Safari iOS
        // When navigation starts, Safari stops execution of CSS and animations
        // With this timeout, we wait until the menu close animation is finished
        setTimeout(() => {
          this.navigate();
        }, 350);
      } else {
        this.$emit('click');
      }
    },
    navigate() {
      if (isAbsoluteUrl(this.href)) {
        window.location.href = this.href;
      } else {
        this.$router.push(this.href);
      }
    },
  },
};
</script>
